module.exports = __webpack_public_path__ + "img/logo-white.20374205.png";